var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"battery-level-indicator"},[_c('div',{class:{
      'battery-level-indicator--red': _vm.batteryStatus.color === 'red',
      'battery-level-indicator--green': _vm.batteryStatus.color === 'green',
    }},[_c('b-icon',{attrs:{"size":"small","colored":"","icon":_vm.batteryStatus.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(`${_vm.batteryPercentage} %`))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }